// Generated by Melange

import * as Caml_exceptions from "melange.js/caml_exceptions.js";
import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Curry from "melange.js/curry.js";
import * as Ocaml_protoc_plugin__Field from "./field.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__Format from "melange/format.js";
import * as Stdlib__Option from "melange/option.js";
import * as Stdlib__Printexc from "melange/printexc.js";
import * as Stdlib__Printf from "melange/printf.js";

const $$Error = /* @__PURE__ */ Caml_exceptions.create("Ocaml_protoc_plugin__Result.Error");

function raise(error) {
  throw new Caml_js_exceptions.MelangeError($$Error, {
        MEL_EXN_ID: $$Error,
        _1: error
      });
}

function $$catch(f) {
  try {
    return {
      TAG: /* Ok */ 0,
      _0: Curry._1(f, undefined)
    };
  }
  catch (raw_v){
    const v = Caml_js_exceptions.internalToOCamlException(raw_v);
    if (v.MEL_EXN_ID === $$Error) {
      return {
        TAG: /* Error */ 1,
        _0: v._1
      };
    }
    throw new Caml_js_exceptions.MelangeError(v.MEL_EXN_ID, v);
  }
}

function $great$great$pipe(x) {
  if (x.TAG === /* Ok */ 0) {
    const x$1 = x._0;
    return function (f) {
      return {
        TAG: /* Ok */ 0,
        _0: Curry._1(f, x$1)
      };
    };
  }
  const err = x._0;
  return function (param) {
    return {
      TAG: /* Error */ 1,
      _0: err
    };
  };
}

function $great$great$eq(x) {
  if (x.TAG === /* Ok */ 0) {
    const x$1 = x._0;
    return function (f) {
      return Curry._1(f, x$1);
    };
  }
  const err = x._0;
  return function (param) {
    return {
      TAG: /* Error */ 1,
      _0: err
    };
  };
}

function $$return(x) {
  return {
    TAG: /* Ok */ 0,
    _0: x
  };
}

function fail(x) {
  return {
    TAG: /* Error */ 1,
    _0: x
  };
}

function get(msg, v) {
  if (v.TAG === /* Ok */ 0) {
    return v._0;
  } else {
    return Stdlib.failwith(msg);
  }
}

function pp_error(fmt, param) {
  if (typeof param === "string") {
    if (param === "Premature_end_of_input") {
      return Stdlib__Format.pp_print_string(fmt, "`Premature_end_of_input");
    } else {
      return Stdlib__Format.pp_print_string(fmt, "`Oneof_missing");
    }
  }
  const variant = param.NAME;
  if (variant === "Unknown_enum_name") {
    Stdlib__Format.fprintf(fmt)({
      TAG: /* Format */ 0,
      _0: {
        TAG: /* String_literal */ 11,
        _0: "`Unknown_enum_name (",
        _1: {
          TAG: /* Formatting_gen */ 18,
          _0: {
            TAG: /* Open_box */ 1,
            _0: {
              TAG: /* Format */ 0,
              _0: {
                TAG: /* String_literal */ 11,
                _0: "<hov>",
                _1: /* End_of_format */ 0
              },
              _1: "<hov>"
            }
          },
          _1: /* End_of_format */ 0
        }
      },
      _1: "`Unknown_enum_name (@[<hov>"
    });
    Curry._1(Stdlib__Format.fprintf(fmt)({
      TAG: /* Format */ 0,
      _0: {
        TAG: /* String */ 2,
        _0: /* No_padding */ 0,
        _1: /* End_of_format */ 0
      },
      _1: "%s"
    }), param.VAL);
    return Stdlib__Format.fprintf(fmt)({
      TAG: /* Format */ 0,
      _0: {
        TAG: /* Formatting_lit */ 17,
        _0: /* Close_box */ 0,
        _1: {
          TAG: /* Char_literal */ 12,
          _0: /* ')' */41,
          _1: /* End_of_format */ 0
        }
      },
      _1: "@])"
    });
  }
  if (variant === "Required_field_missing") {
    const x = param.VAL;
    Stdlib__Format.fprintf(fmt)({
      TAG: /* Format */ 0,
      _0: {
        TAG: /* String_literal */ 11,
        _0: "`Required_field_missing (",
        _1: {
          TAG: /* Formatting_gen */ 18,
          _0: {
            TAG: /* Open_box */ 1,
            _0: {
              TAG: /* Format */ 0,
              _0: {
                TAG: /* String_literal */ 11,
                _0: "<hov>",
                _1: /* End_of_format */ 0
              },
              _1: "<hov>"
            }
          },
          _1: /* End_of_format */ 0
        }
      },
      _1: "`Required_field_missing (@[<hov>"
    });
    Stdlib__Format.fprintf(fmt)({
      TAG: /* Format */ 0,
      _0: {
        TAG: /* Char_literal */ 12,
        _0: /* '(' */40,
        _1: {
          TAG: /* Formatting_gen */ 18,
          _0: {
            TAG: /* Open_box */ 1,
            _0: {
              TAG: /* Format */ 0,
              _0: /* End_of_format */ 0,
              _1: ""
            }
          },
          _1: /* End_of_format */ 0
        }
      },
      _1: "(@["
    });
    Curry._1(Stdlib__Format.fprintf(fmt)({
      TAG: /* Format */ 0,
      _0: {
        TAG: /* Int */ 4,
        _0: /* Int_d */ 0,
        _1: /* No_padding */ 0,
        _2: /* No_precision */ 0,
        _3: /* End_of_format */ 0
      },
      _1: "%d"
    }), x[0]);
    Stdlib__Format.fprintf(fmt)({
      TAG: /* Format */ 0,
      _0: {
        TAG: /* Char_literal */ 12,
        _0: /* ',' */44,
        _1: {
          TAG: /* Formatting_lit */ 17,
          _0: {
            TAG: /* Break */ 0,
            _0: "@ ",
            _1: 1,
            _2: 0
          },
          _1: /* End_of_format */ 0
        }
      },
      _1: ",@ "
    });
    Curry._1(Stdlib__Format.fprintf(fmt)({
      TAG: /* Format */ 0,
      _0: {
        TAG: /* String */ 2,
        _0: /* No_padding */ 0,
        _1: /* End_of_format */ 0
      },
      _1: "%s"
    }), x[1]);
    Stdlib__Format.fprintf(fmt)({
      TAG: /* Format */ 0,
      _0: {
        TAG: /* Formatting_lit */ 17,
        _0: /* Close_box */ 0,
        _1: {
          TAG: /* Char_literal */ 12,
          _0: /* ')' */41,
          _1: /* End_of_format */ 0
        }
      },
      _1: "@])"
    });
    return Stdlib__Format.fprintf(fmt)({
      TAG: /* Format */ 0,
      _0: {
        TAG: /* Formatting_lit */ 17,
        _0: /* Close_box */ 0,
        _1: {
          TAG: /* Char_literal */ 12,
          _0: /* ')' */41,
          _1: /* End_of_format */ 0
        }
      },
      _1: "@])"
    });
  }
  if (variant === "Wrong_field_type") {
    const x$1 = param.VAL;
    Stdlib__Format.fprintf(fmt)({
      TAG: /* Format */ 0,
      _0: {
        TAG: /* String_literal */ 11,
        _0: "`Wrong_field_type (",
        _1: {
          TAG: /* Formatting_gen */ 18,
          _0: {
            TAG: /* Open_box */ 1,
            _0: {
              TAG: /* Format */ 0,
              _0: {
                TAG: /* String_literal */ 11,
                _0: "<hov>",
                _1: /* End_of_format */ 0
              },
              _1: "<hov>"
            }
          },
          _1: /* End_of_format */ 0
        }
      },
      _1: "`Wrong_field_type (@[<hov>"
    });
    Stdlib__Format.fprintf(fmt)({
      TAG: /* Format */ 0,
      _0: {
        TAG: /* Char_literal */ 12,
        _0: /* '(' */40,
        _1: {
          TAG: /* Formatting_gen */ 18,
          _0: {
            TAG: /* Open_box */ 1,
            _0: {
              TAG: /* Format */ 0,
              _0: /* End_of_format */ 0,
              _1: ""
            }
          },
          _1: /* End_of_format */ 0
        }
      },
      _1: "(@["
    });
    Curry._1(Stdlib__Format.fprintf(fmt)({
      TAG: /* Format */ 0,
      _0: {
        TAG: /* Caml_string */ 3,
        _0: /* No_padding */ 0,
        _1: /* End_of_format */ 0
      },
      _1: "%S"
    }), x$1[0]);
    Stdlib__Format.fprintf(fmt)({
      TAG: /* Format */ 0,
      _0: {
        TAG: /* Char_literal */ 12,
        _0: /* ',' */44,
        _1: {
          TAG: /* Formatting_lit */ 17,
          _0: {
            TAG: /* Break */ 0,
            _0: "@ ",
            _1: 1,
            _2: 0
          },
          _1: /* End_of_format */ 0
        }
      },
      _1: ",@ "
    });
    Curry._1(Stdlib__Format.fprintf(fmt)({
      TAG: /* Format */ 0,
      _0: {
        TAG: /* Caml_string */ 3,
        _0: /* No_padding */ 0,
        _1: /* End_of_format */ 0
      },
      _1: "%S"
    }), x$1[1]);
    Stdlib__Format.fprintf(fmt)({
      TAG: /* Format */ 0,
      _0: {
        TAG: /* Formatting_lit */ 17,
        _0: /* Close_box */ 0,
        _1: {
          TAG: /* Char_literal */ 12,
          _0: /* ')' */41,
          _1: /* End_of_format */ 0
        }
      },
      _1: "@])"
    });
    return Stdlib__Format.fprintf(fmt)({
      TAG: /* Format */ 0,
      _0: {
        TAG: /* Formatting_lit */ 17,
        _0: /* Close_box */ 0,
        _1: {
          TAG: /* Char_literal */ 12,
          _0: /* ')' */41,
          _1: /* End_of_format */ 0
        }
      },
      _1: "@])"
    });
  }
  if (variant === "Unknown_enum_value") {
    Stdlib__Format.fprintf(fmt)({
      TAG: /* Format */ 0,
      _0: {
        TAG: /* String_literal */ 11,
        _0: "`Unknown_enum_value (",
        _1: {
          TAG: /* Formatting_gen */ 18,
          _0: {
            TAG: /* Open_box */ 1,
            _0: {
              TAG: /* Format */ 0,
              _0: {
                TAG: /* String_literal */ 11,
                _0: "<hov>",
                _1: /* End_of_format */ 0
              },
              _1: "<hov>"
            }
          },
          _1: /* End_of_format */ 0
        }
      },
      _1: "`Unknown_enum_value (@[<hov>"
    });
    Curry._1(Stdlib__Format.fprintf(fmt)({
      TAG: /* Format */ 0,
      _0: {
        TAG: /* Int */ 4,
        _0: /* Int_d */ 0,
        _1: /* No_padding */ 0,
        _2: /* No_precision */ 0,
        _3: /* End_of_format */ 0
      },
      _1: "%d"
    }), param.VAL);
    return Stdlib__Format.fprintf(fmt)({
      TAG: /* Format */ 0,
      _0: {
        TAG: /* Formatting_lit */ 17,
        _0: /* Close_box */ 0,
        _1: {
          TAG: /* Char_literal */ 12,
          _0: /* ')' */41,
          _1: /* End_of_format */ 0
        }
      },
      _1: "@])"
    });
  }
  if (variant === "Illegal_value") {
    const x$2 = param.VAL;
    Stdlib__Format.fprintf(fmt)({
      TAG: /* Format */ 0,
      _0: {
        TAG: /* String_literal */ 11,
        _0: "`Illegal_value (",
        _1: {
          TAG: /* Formatting_gen */ 18,
          _0: {
            TAG: /* Open_box */ 1,
            _0: {
              TAG: /* Format */ 0,
              _0: {
                TAG: /* String_literal */ 11,
                _0: "<hov>",
                _1: /* End_of_format */ 0
              },
              _1: "<hov>"
            }
          },
          _1: /* End_of_format */ 0
        }
      },
      _1: "`Illegal_value (@[<hov>"
    });
    Stdlib__Format.fprintf(fmt)({
      TAG: /* Format */ 0,
      _0: {
        TAG: /* Char_literal */ 12,
        _0: /* '(' */40,
        _1: {
          TAG: /* Formatting_gen */ 18,
          _0: {
            TAG: /* Open_box */ 1,
            _0: {
              TAG: /* Format */ 0,
              _0: /* End_of_format */ 0,
              _1: ""
            }
          },
          _1: /* End_of_format */ 0
        }
      },
      _1: "(@["
    });
    Curry._1(Stdlib__Format.fprintf(fmt)({
      TAG: /* Format */ 0,
      _0: {
        TAG: /* Caml_string */ 3,
        _0: /* No_padding */ 0,
        _1: /* End_of_format */ 0
      },
      _1: "%S"
    }), x$2[0]);
    Stdlib__Format.fprintf(fmt)({
      TAG: /* Format */ 0,
      _0: {
        TAG: /* Char_literal */ 12,
        _0: /* ',' */44,
        _1: {
          TAG: /* Formatting_lit */ 17,
          _0: {
            TAG: /* Break */ 0,
            _0: "@ ",
            _1: 1,
            _2: 0
          },
          _1: /* End_of_format */ 0
        }
      },
      _1: ",@ "
    });
    Ocaml_protoc_plugin__Field.pp(fmt, x$2[1]);
    Stdlib__Format.fprintf(fmt)({
      TAG: /* Format */ 0,
      _0: {
        TAG: /* Formatting_lit */ 17,
        _0: /* Close_box */ 0,
        _1: {
          TAG: /* Char_literal */ 12,
          _0: /* ')' */41,
          _1: /* End_of_format */ 0
        }
      },
      _1: "@])"
    });
    return Stdlib__Format.fprintf(fmt)({
      TAG: /* Format */ 0,
      _0: {
        TAG: /* Formatting_lit */ 17,
        _0: /* Close_box */ 0,
        _1: {
          TAG: /* Char_literal */ 12,
          _0: /* ')' */41,
          _1: /* End_of_format */ 0
        }
      },
      _1: "@])"
    });
  }
  Stdlib__Format.fprintf(fmt)({
    TAG: /* Format */ 0,
    _0: {
      TAG: /* String_literal */ 11,
      _0: "`Unknown_field_type (",
      _1: {
        TAG: /* Formatting_gen */ 18,
        _0: {
          TAG: /* Open_box */ 1,
          _0: {
            TAG: /* Format */ 0,
            _0: {
              TAG: /* String_literal */ 11,
              _0: "<hov>",
              _1: /* End_of_format */ 0
            },
            _1: "<hov>"
          }
        },
        _1: /* End_of_format */ 0
      }
    },
    _1: "`Unknown_field_type (@[<hov>"
  });
  Curry._1(Stdlib__Format.fprintf(fmt)({
    TAG: /* Format */ 0,
    _0: {
      TAG: /* Int */ 4,
      _0: /* Int_d */ 0,
      _1: /* No_padding */ 0,
      _2: /* No_precision */ 0,
      _3: /* End_of_format */ 0
    },
    _1: "%d"
  }), param.VAL);
  Stdlib__Format.fprintf(fmt)({
    TAG: /* Format */ 0,
    _0: {
      TAG: /* Formatting_lit */ 17,
      _0: /* Close_box */ 0,
      _1: {
        TAG: /* Char_literal */ 12,
        _0: /* ')' */41,
        _1: /* End_of_format */ 0
      }
    },
    _1: "@])"
  });
}

const show_error = Curry._1(Stdlib__Format.asprintf({
  TAG: /* Format */ 0,
  _0: {
    TAG: /* Alpha */ 15,
    _0: /* End_of_format */ 0
  },
  _1: "%a"
}), pp_error);

Stdlib__Printexc.register_printer(function (e) {
  if (e.MEL_EXN_ID === $$Error) {
    return Stdlib__Option.some(Curry._1(Stdlib__Printf.sprintf({
      TAG: /* Format */ 0,
      _0: {
        TAG: /* String_literal */ 11,
        _0: "Ocaml_protoc_plugin.Result.Error (",
        _1: {
          TAG: /* String */ 2,
          _0: /* No_padding */ 0,
          _1: {
            TAG: /* Char_literal */ 12,
            _0: /* ')' */41,
            _1: /* End_of_format */ 0
          }
        }
      },
      _1: "Ocaml_protoc_plugin.Result.Error (%s)"
    }), Curry._1(show_error, e._1)));
  }
  
});

function pp(pp$1, fmt, v) {
  if (v.TAG === /* Ok */ 0) {
    return Curry._2(Stdlib__Format.fprintf(fmt)({
      TAG: /* Format */ 0,
      _0: {
        TAG: /* String_literal */ 11,
        _0: "Ok ",
        _1: {
          TAG: /* Alpha */ 15,
          _0: /* End_of_format */ 0
        }
      },
      _1: "Ok %a"
    }), pp$1, v._0);
  } else {
    return Curry._2(Stdlib__Format.fprintf(fmt)({
      TAG: /* Format */ 0,
      _0: {
        TAG: /* String_literal */ 11,
        _0: "Error ",
        _1: {
          TAG: /* Alpha */ 15,
          _0: /* End_of_format */ 0
        }
      },
      _1: "Error %a"
    }), pp_error, v._0);
  }
}

export {
  $$Error,
  raise,
  $$catch,
  $great$great$pipe,
  $great$great$eq,
  $$return,
  fail,
  get,
  pp_error,
  show_error,
  pp,
}
/* show_error Not a pure module */
